<template>

    <div class="Rebate">
        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
            id="loader">
            <b-row>
                <b-col cols="12 headerF">
                    <HeaderFixed />
                </b-col>
                <b-col cols="12 headerM">
                    <HeaderMobile />
                </b-col>
            </b-row>
            <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

                <b-row>
                    <b-col cols="12">
                        <b-breadcrumb style="background-color: #e9ecef78;">
                        <b-breadcrumb-item to="/">
                            <b-icon
                            icon="house-door"
                            scale="1.25"
                            shift-v="1.25"
                            aria-hidden="true"
                            ></b-icon>
                            Home
                        </b-breadcrumb-item>

                        <b-breadcrumb-item>
                            <router-link to="/EodbReport">
                                EODB
                            </router-link>
                        </b-breadcrumb-item>

                        <b-breadcrumb-item active>
                            Dashboard for Planned Power Outage
                        </b-breadcrumb-item>
                        </b-breadcrumb>
                    </b-col>
                </b-row>
                <hr />


                <div id="plannedOutageDistDetails" v-show="hasSearched" class="centerWrapper">
                    <div id="plannedtableShow" class="mt-3 tableCard" v-show="report.length > 0">
                        <h5 class="tableTitle">Dashboard for Planned Power Outage</h5>

                        <b-tabs v-model="activeTabIndex" nav-class="reportTabsNav" content-class="mt-3" active-nav-item-class="activeReportTab">
                            <!-- ===================== TAB 1: DAILY DETAIL REPORT ===================== -->
                            <b-tab title="Daily Planned Outage">
                                <div class="asOnRow">
                                    Data as on: <span class="asOnValue">{{ reportTimestamp }}</span>
                                </div>

                                <b-row class="filterRow">
                                    <b-col cols="12" md="4" class="filterLabel">
                                        Filter by Sub-Division:
                                    </b-col>
                                    <b-col cols="12" md="5">
                                        <b-form-select v-model="selectedSubdiv" :options="subdivOptions" size="sm"
                                            class="w-100"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="3" v-if="selectedSubdiv">
                                        <b-button variant="outline-secondary" size="sm" @click="selectedSubdiv = ''">
                                            Clear Filter
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <div class="tableScrollWrapper">
                                    <b-table bordered hover responsive sticky-header="420px" :items="filteredReport"
                                        :fields="reportFields" class="text-center prettyTable" show-empty>
                                    </b-table>
                                </div>
                            </b-tab>

                            <!-- ===================== TAB 2: MONTHLY SUB-DIVISION WISE COUNT ===================== -->
                            <b-tab title="Monthly Count (Sub-Division wise)">
                                <div class="asOnRow">
                                    For <span class="asOnValue">{{ monthlyPeriodLabel }}</span><span v-if="monthlyTotalCount > 0"> · Total Approved Shutdowns: <span class="asOnValue">{{ monthlyTotalCount }}</span></span> · Data as on <span class="asOnValue">{{ reportTimestamp }}</span>
                                </div>

                                <b-row class="filterRow">
                                    <b-col cols="12" md="4" class="filterLabel">
                                        Filter by Sub-Division:
                                    </b-col>
                                    <b-col cols="12" md="5">
                                        <b-form-select v-model="selectedSubdivMonthly" :options="monthlySubdivOptions"
                                            size="sm" class="w-100"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="3" v-if="selectedSubdivMonthly">
                                        <b-button variant="outline-secondary" size="sm" @click="selectedSubdivMonthly = ''">
                                            Clear Filter
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <div class="tableScrollWrapper">
                                    <b-table bordered hover responsive sticky-header="420px" :items="monthlyCountReport"
                                        :fields="countFields" :tbody-tr-class="totalRowClass" class="text-center prettyTable" show-empty>
                                    </b-table>
                                </div>
                            </b-tab>

                            <!-- ===================== TAB 3: QUARTERLY SUB-DIVISION WISE COUNT ===================== -->
                            <b-tab title="Quarterly Count (Sub-Division wise)">
                                <div class="asOnRow">
                                    For <span class="asOnValue">{{ quarterlyPeriodLabel }}</span><span v-if="quarterlyTotalCount > 0"> · Total Approved Shutdowns: <span class="asOnValue">{{ quarterlyTotalCount }}</span></span> · Data as on <span class="asOnValue">{{ reportTimestamp }}</span>
                                </div>

                                <b-row class="filterRow">
                                    <b-col cols="12" md="4" class="filterLabel">
                                        Filter by Sub-Division:
                                    </b-col>
                                    <b-col cols="12" md="5">
                                        <b-form-select v-model="selectedSubdivQuarterly" :options="quarterlySubdivOptions"
                                            size="sm" class="w-100"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" md="3" v-if="selectedSubdivQuarterly">
                                        <b-button variant="outline-secondary" size="sm" @click="selectedSubdivQuarterly = ''">
                                            Clear Filter
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <div class="tableScrollWrapper">
                                    <b-table bordered hover responsive sticky-header="420px" :items="quarterlyCountReport"
                                        :fields="countFields" :tbody-tr-class="totalRowClass" class="text-center prettyTable" show-empty>
                                    </b-table>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                    <div id="noData" v-show="hasSearched && report.length === 0" class="noDataBox">
                        No planned outage data available currently.
                    </div>
                    <br>
                </div>
                <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
                    <span class="data" id="msg">{{ modalMessage }}</span>
                    <br><br>
                    <b-button style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
                </b-modal>
            </b-container>

            <br><br>
        </b-overlay>

    </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var thColor = '#0d47a1';

function thStyleFor(width) {
    return { width: width, backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center', verticalAlign: 'middle', padding: '0.75rem 0.5rem' };
}

function toRomanNumeral(num) {
    const romanMap = [
        [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
        [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
        [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
    ];
    let result = '';
    romanMap.forEach(([value, symbol]) => {
        while (num >= value) {
            result += symbol;
            num -= value;
        }
    });
    return result;
}


function formatSubdivName(raw) {
    if (!raw) return "Other";
    const trimmed = raw.trim();
    const match = trimmed.match(/^(.*?)[\s\-_]*([0-9]+)$/);

    if (match && match[1]) {
        const namePart = match[1].trim();
        const numPart = parseInt(match[2], 10);
        if (namePart && !isNaN(numPart) && numPart > 0) {
            const capitalizedName = namePart.charAt(0).toUpperCase() + namePart.slice(1);
            return `${capitalizedName}-${toRomanNumeral(numPart)}`;
        }
    }

    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}

export default {
    name: 'PayBill',
    components: {
        'HeaderFixed': HeaderFixed,
        'HeaderMobile': HeaderMobile
    },

    data() {
        return {
            selected: null,
            hasSearched: false,
            modalMessage: '',
            activeTabIndex: 0,

            
            selectedSubdiv: '',            // Daily detail table
            selectedSubdivMonthly: '',     // Monthly count table
            selectedSubdivQuarterly: '',   // Quarterly count table

            // ----- Daily detail report -----
            reportFields: [
                { key: 'circle_division', label: 'Circle / Division Name', thStyle: thStyleFor('15vw') },
                { key: 'subdiv', label: 'Sub-Division', thStyle: thStyleFor('20vw') },
                { key: 'ss', label: 'Sub-Station', thStyle: thStyleFor('20vw') },
                { key: 'feeder', label: 'Feeder', thStyle: thStyleFor('20vw') },
                { key: 'shutdown_start', label: 'Shut Down Start Time', thStyle: thStyleFor('15vw') },
                { key: 'shutdown_end', label: 'Shut Down End Time', thStyle: thStyleFor('15vw') },
                { key: 'reason', label: 'Major reasons for power disruption', thStyle: thStyleFor('25vw') },
            ],
            report: [],
            reportTimestamp: '',

            serverToday: null,
            countFields: [
                { key: 'subdiv', label: 'Sub-Division', thStyle: thStyleFor('30vw') },
                { key: 'count', label: 'Total Outage Count', thStyle: thStyleFor('17vw') },
                { key: 'totalMinutes', label: 'Total Outage Period', thStyle: thStyleFor('17vw'), formatter: (value) => this.formatDurationLabel(value) },
            ],
            monthlyReport: [],
            monthlyFrom: '',
            monthlyTo: '',
            quarterlyReport: [],
            quarterlyFrom: '',
            quarterlyTo: '',

            show: false,
        }
    },
    computed: {
        subdivOptions() {
            return this.buildSubdivOptions(this.report);
        },
        filteredReport() {
            let list = this.selectedSubdiv
                ? this.report.filter(item => item.subdiv === this.selectedSubdiv)
                : this.report;

            return [...list].sort((a, b) => {

             
                const startA = new Date(a.shutdown_start);
                const startB = new Date(b.shutdown_start);
                const validA = !isNaN(startA);
                const validB = !isNaN(startB);

                if (validA && validB && startA.getTime() !== startB.getTime()) {
                    return startA - startB;
                }
                if (validA !== validB) return validA ? -1 : 1;
                if (a.subdiv === "Other") return 1;
                if (b.subdiv === "Other") return -1;

                return (a.subdiv || "").localeCompare(b.subdiv || "");
            });
        },

        monthlyCountRows() {
            return this.buildCountReport(this.monthlyReport);
        },
     
        quarterlyCountRows() {
            return this.buildCountReport(this.quarterlyReport);
        },

        monthlyTotalCount() {
            return this.monthlyReport.length;
        },

        quarterlyTotalCount() {
            return this.quarterlyReport.length;
        },


        monthlyPeriodLabel() {
            return this.formatPeriodLabel(this.monthlyFrom, this.monthlyTo);
        },

        quarterlyPeriodLabel() {
            return this.formatPeriodLabel(this.quarterlyFrom, this.quarterlyTo);
        },


        monthlySubdivOptions() {
            return this.buildSubdivOptions(this.monthlyCountRows);
        },
        quarterlySubdivOptions() {
            return this.buildSubdivOptions(this.quarterlyCountRows);
        },

 
        monthlyCountReport() {
            const rows = this.selectedSubdivMonthly
                ? this.monthlyCountRows.filter(row => row.subdiv === this.selectedSubdivMonthly)
                : this.monthlyCountRows;
            return this.addTotalRow(rows);
        },
        quarterlyCountReport() {
            const rows = this.selectedSubdivQuarterly
                ? this.quarterlyCountRows.filter(row => row.subdiv === this.selectedSubdivQuarterly)
                : this.quarterlyCountRows;
            return this.addTotalRow(rows);
        }
    },
    methods:
    {
  
        getReferenceToday() {
            return this.serverToday || new Date();
        },
        getCurrentDate() {

            return this.formatDate(this.getReferenceToday());
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        formatTimestamp(date) {
            const datePart = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
            const timePart = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
            return `${datePart}, ${timePart}`;
        },

        getServerTimestamp(response) {
            const headerDate = response && response.headers ? response.headers['date'] : null;
            const parsed = headerDate ? new Date(headerDate) : null;

            if (parsed && !isNaN(parsed)) {
                return parsed;
            }
            // console.warn('Server Date header unavailable, falling back to client clock for timestamp.');
            return new Date();
        },

        formatPeriodLabel(fromStr, toStr) {
            if (!fromStr || !toStr) return '';

            const parseLocalDate = (s) => {
                const [y, m, d] = s.split('-').map(Number);
                return new Date(y, m - 1, d);
            };
            const fmt = (d) => d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });

            const from = parseLocalDate(fromStr);
            const to = parseLocalDate(toStr);
            if (isNaN(from) || isNaN(to)) return '';

            return `${fmt(from)} \u2013 ${fmt(to)}`;
        },

        mapApprovedData(data) {
            var approved = (data || []).filter(element => element.status === "APPROVED");
            return approved.map(element => ({
                circle_division: `${element.circle || ""} / ${element.division || ""}`,
                subdiv: formatSubdivName(element.esd_name),
                ss: element.ss || "",
                feeder: element.feeder || "",
                shutdown_start: element.shutdown_in || "",
                shutdown_end: element.shutdown_out || "",
                reason: element.remarks || ""
            }));
        },

        outageDurationMinutes(shutdownStart, shutdownEnd) {
            const start = new Date(shutdownStart);
            const end = new Date(shutdownEnd);
            if (isNaN(start) || isNaN(end)) return 0;

            let diffMs = end - start;
            if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000; // rolled over past midnight
            return diffMs / 60000;
        },

        formatDurationLabel(totalMinutes) {
            const minutes = Math.max(0, Math.round(totalMinutes || 0));
            const hrs = Math.floor(minutes / 60);
            const mins = minutes % 60;
            return `${hrs}h ${mins}m`;
        },

        buildCountReport(list) {
            const counts = {};
            (list || []).forEach(item => {
                const key = item.subdiv || "Other";
                if (!counts[key]) counts[key] = { count: 0, minutes: 0 };
                counts[key].count += 1;
                counts[key].minutes += this.outageDurationMinutes(item.shutdown_start, item.shutdown_end);
            });

            const subdivs = Object.keys(counts).sort((a, b) => {
                if (a === "Other") return 1;
                if (b === "Other") return -1;
                return a.localeCompare(b);
            });

            return subdivs.map(subdiv => ({
                subdiv: subdiv,
                count: counts[subdiv].count,
                totalMinutes: counts[subdiv].minutes
            }));
        },

        addTotalRow(rows) {
            if (!rows || rows.length === 0) return rows;
            const total = rows.reduce((sum, row) => sum + row.count, 0);
            const totalMinutes = rows.reduce((sum, row) => sum + row.totalMinutes, 0);
            return [...rows, { subdiv: 'Total', count: total, totalMinutes: totalMinutes }];
        },

        buildSubdivOptions(list) {
            let unique = [...new Set((list || []).map(item => item.subdiv))];

            unique.sort((a, b) => {
                if (a === "Other") return 1;
                if (b === "Other") return -1;
                return (a || "").localeCompare(b || "");
            });

            return [
                { value: "", text: "All Sub-Divisions" },
                ...unique.map(item => ({ value: item, text: item }))
            ];
        },

        fetchMonthlyData() {
            return axios.get(this.$urlCommon + "/api/web/periodicShutdownData?period=m")
                .then(response => {
                    var success = response.data.status;

                    if (success == true) {
                        this.monthlyReport = this.mapApprovedData(response.data.result || []);
                        this.monthlyFrom = response.data.from || '';
                        this.monthlyTo = response.data.to || '';
                    } else {
                        this.monthlyReport = [];
                        this.monthlyFrom = '';
                        this.monthlyTo = '';
                    }
                })
                .catch(error => {
                    // console.error('Error fetching monthly periodic data:', error);
                    this.monthlyReport = [];
                    this.monthlyFrom = '';
                    this.monthlyTo = '';
                });
        },
 
        fetchQuarterlyData() {
            return axios.get(this.$urlCommon + "/api/web/periodicShutdownData?period=q")
                .then(response => {
                    var success = response.data.status;

                    if (success == true) {
                        this.quarterlyReport = this.mapApprovedData(response.data.result || []);
                        this.quarterlyFrom = response.data.from || '';
                        this.quarterlyTo = response.data.to || '';
                    } else {
                        this.quarterlyReport = [];
                        this.quarterlyFrom = '';
                        this.quarterlyTo = '';
                    }
                })
                .catch(error => {
                    // console.error('Error fetching quarterly periodic data:', error);
                    this.quarterlyReport = [];
                    this.quarterlyFrom = '';
                    this.quarterlyTo = '';
                });
        },
        showDetails() {
            const currentDate = this.getCurrentDate();
            // console.log("Current Date:", currentDate);

            this.show = true;
            this.selectedSubdiv = '';
            this.selectedSubdivMonthly = '';
            this.selectedSubdivQuarterly = '';

            const dailyRequest = axios.get(this.$urlCommon + "/api/web/shutdownData?date="+currentDate)
                .then(response => {
                    this.hasSearched = true;

                    var success = response.data.status;
                    var data = response.data.result || [];

                    // console.log("Raw API response:", response.data);


                    this.serverToday = this.getServerTimestamp(response);
                    this.reportTimestamp = this.formatTimestamp(this.serverToday);

                    if (success == true) {
                        this.report = this.mapApprovedData(data);

                        // console.log("Mapped report data:", this.report);
                    }
                    else {
                        this.report = [];
                        this.modalMessage = "Sorry, Please Try Again Later";
                        this.$bvModal.show('model');
                    }
                })
                .catch(error => {
                    this.hasSearched = false;
                    // console.error('Error:', error);
                    this.modalMessage = "Sorry, Please Try Again Later";
                    this.$bvModal.show('model');
                });

   
            Promise.all([dailyRequest, this.fetchMonthlyData(), this.fetchQuarterlyData()])
                .then(() => {
                    this.show = false;
                })
                .catch(() => {
                    this.show = false;
                });
        },

        totalRowClass(item) {
            return item && item.subdiv === 'Total' ? 'totalRow' : '';
        },
        closeModal() {
            this.$bvModal.hide('model');
        }
    },
    mounted() {
        this.showDetails();
    }
}


</script>

<style scoped="true">
/deep/ .table>tbody>tr>td {
    font-size: 0.85rem;
    font-weight: 500;
    color: #333;
    vertical-align: middle;
    padding: 0.65rem 0.5rem;
}

.centerWrapper {
    width: 90vw;
    max-width: 1200px;
    margin: 0 auto;
    font-size: 0.8rem;
}

.tableCard {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    padding: 1.25rem 1.25rem 0.5rem 1.25rem;
    border: 1px solid #e6e9ee;
}

.tableTitle {
    text-align: center;
    color: #0d47a1;
    font-weight: 700;
    font-size: 1.05rem;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e6e9ee;
    letter-spacing: 0.3px;
}

/deep/ .reportTabsNav {
    border-bottom: 2px solid #e6e9ee;
}

/deep/ .reportTabsNav .nav-link {
    font-weight: 600;
    color: #0d47a1;
}

/deep/ .reportTabsNav .activeReportTab {
    color: #ffffff !important;
    background-color: #0d47a1 !important;
    border-color: #0d47a1 !important;
}

.asOnRow {
    text-align: right;
    font-size: 0.85rem;
    font-weight: 600;
    color: #555;
    margin-bottom: 0.75rem;
}

.asOnValue {
    color: #0d47a1;
    font-weight: 700;
}

@media (max-width: 768px) {
    .asOnRow {
        text-align: left;
    }
}

.filterRow {
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px dashed #e6e9ee;
}

.filterLabel {
    font-weight: 600;
    color: #0d47a1;
    text-align: right;
}

@media (max-width: 768px) {
    .filterLabel {
        text-align: left;
        margin-bottom: 0.4rem;
    }
}

/* Keeps each table's height bounded (with an internal scrollbar + sticky header)
   instead of letting a long list stretch the whole page. */
.tableScrollWrapper {
    max-height: 440px;
    overflow: hidden;
}

/deep/ .prettyTable {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 0;
}

/deep/ .prettyTable.b-table-sticky-header {
    max-height: 420px;
    overflow-y: auto;
}

/deep/ .prettyTable thead th {
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    border: none !important;
    position: sticky;
    top: 0;
    z-index: 1;
}

/deep/ .prettyTable tbody tr {
    transition: background-color 0.15s ease-in-out;
}

/deep/ .prettyTable tbody tr:nth-of-type(odd) {
    background-color: #f7f9fc;
}

/deep/ .prettyTable tbody tr:hover {
    background-color: #e3f2fd !important;
}

/deep/ .prettyTable tbody td {
    border-color: #eef1f5 !important;
}

/deep/ .prettyTable tbody tr.totalRow {
    font-weight: 700;
    background-color: #eef3fb !important;
}

/deep/ .prettyTable tbody tr.totalRow td {
    color: #0d47a1;
}

.noDataBox {
    text-align: center;
    font-size: 1.1rem;
    color: #9F3A22;
    background: #fff5f2;
    border: 1px solid #f3d3c8;
    border-radius: 8px;
    padding: 1.5rem;
    margin-top: 1rem;
}

.paddingRow {
    padding: 0.7rem;
}

.paddingCol {
    padding: none;
}

.label {
    font-weight: 600;
}

.data {
    font-weight: 600;
    color: #ff5722;
    font-size: 1.2rem;
}

.hideDetails {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
    box-shadow: 2px 2px 10px 2px #bdbdbd;
    padding: 1rem;
    margin-right: 1.5rem;
}

.showDetails {

    visibility: visible;
    opacity: 1;
}

hr {
    margin-top: 5px;
    margin-bottom: 5px;
}

.go:focus {
    box-shadow: none;
}

.headerF {
    display: block;
}

.headerM {
    display: none;
}

.paddingLeft30px {
    padding-left: 30px;
}

.dorpDownMarginTop {
    margin-top: -16px;
}

.alignAndPadding {
    text-align: right;
    padding-right: 0;
}

@media (max-width: 768px) {
    .headerF {
        display: none;
    }

    .headerM {
        display: block;
    }

    .paddingLeft30px {
        padding-left: 0px;
    }

    .dorpDownMarginTop {
        margin-top: 0;
    }

    .alignAndPadding {
        text-align: left;
        margin-top: 12px;
    }
}

@media only screen and (max-width: 414px) {
    .paddingCol {
        padding: 0.7rem;
    }

    .paddingRow {
        padding: none !important;
    }

    .paddingLeft30px {
        padding-left: 0px;
    }

    .dorpDownMarginTop {
        margin-top: 0;
    }

    .smallScreenMargin {
        margin-top: 10px !important;
    }

    .alignAndPadding {
        text-align: left;
    }
}
</style>